import { RESOURCE_TYPE } from "src/constant"

function isImgFile(fileExt: string) {
  return /png|gif|jpe?g|tiff?|svg|bmp|webp/.test(fileExt.toLowerCase());
}

export function getResourceType(resourceEntry: PerformanceResourceTiming): RESOURCE_TYPE {
  const initiatorType = resourceEntry.initiatorType;
  const fileExt = resourceEntry.name.replace(/(\?|#).*$/g, '').split('.').pop();

  switch (true) {
    case initiatorType === 'script':
      return RESOURCE_TYPE.SCRIPT;
    case initiatorType === 'link':
      return RESOURCE_TYPE.LINK;
    case initiatorType === 'xmlhttprequest' || initiatorType === 'fetch':
      return RESOURCE_TYPE.XHR;
    case initiatorType === 'img':
    case isImgFile(fileExt):
      return RESOURCE_TYPE.IMG;
    default:
      return RESOURCE_TYPE.UNKNOWN;
  }
}
